enum PreCheckoutStep {
  insurances,
  error,
}

export default PreCheckoutStep
